import { render, staticRenderFns } from "./flowComponent.vue?vue&type=template&id=b174ae70"
import script from "./flowComponent.vue?vue&type=script&lang=js"
export * from "./flowComponent.vue?vue&type=script&lang=js"
import style0 from "./flowComponent.vue?vue&type=style&index=0&id=b174ae70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports